import { useQuery } from '@tanstack/react-query'
import { getDashboardSummary, type DashboardSummaryParams } from '../api/dashboard'

export const useDashboardSummary = (params?: DashboardSummaryParams) => {
  return useQuery({
    queryKey: ['dashboardSummary', params?.year ?? 'current', params?.month ?? 'current', params],
    queryFn: () => getDashboardSummary(params),
  })
}

